/**
 * «Токены куплены и уже на кошельке» — сигнал страницам, которые показывают
 * баланс (чат специалиста, строка «личный вопрос» на уроке, «Умный поиск»):
 * перечитать его. Шлёт features/tokenPurchase после возврата со Stripe.
 */
export const TOKENS_PURCHASED_EVENT = "tokens-purchased";

export const announceTokensPurchased = (): void => {
    try {
        window.dispatchEvent(new Event(TOKENS_PURCHASED_EVENT));
    } catch {
        /* нет window — нечего оповещать */
    }
};

/** Подписка; возвращает отписку. */
export const onTokensPurchased = (cb: () => void): (() => void) => {
    window.addEventListener(TOKENS_PURCHASED_EVENT, cb);
    return () => window.removeEventListener(TOKENS_PURCHASED_EVENT, cb);
};
